<template>
  <div>
    <b-button
      variant="outline-primary"
      :disabled="loading"
      @click="intiatePOMatch"
    >
      Initiate PO Matching
      <b-spinner
        v-if="loading"
        label="Small Spinner"
        variant="primary"
        small
      />
    </b-button>
  </div>
</template>

<script>
import { BButton, BSpinner } from 'bootstrap-vue'
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BButton,
    BSpinner,
  },
  props: {
    invoiceId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    intiatePOMatch() {
      this.loading = true

      axios.post('/po_invoice_matching/initiate_po_matching/', {
        invoice_id: this.invoiceId,
      })
        .then(res => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Success',
              text: res?.data?.details || 'PO Invoice Match requested',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error',
              text: error?.response?.data?.details || 'Failed to request PO Invoice match',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        }).finally(() => {
          this.loading = false
        })
    },
  },
}

</script>
